import React from 'react';
import { render } from 'react-dom';
import {
  Route,
  Switch,
  Link,
  BrowserRouter as Router
} from 'react-router-dom';
import './stylesheets/main.scss';
import { Header } from './components/header';
import { Toolbar } from './components/toolbar';
import { Home } from './components/home';
import { Search } from './components/search';
import { Cart } from './components/cart';
import { Warehouse } from './components/warehouse';
import { Shipping } from './components/shipping';
import { Help } from './components/help';
import { ProductPage } from './components/productPage';
import Store from './Store';

const App = () => {
  return (
    <Store>
      <Router>
        <div className="root-wrapper">
          <nav id="main-menu" className="main-menu" aria-label="Main menu">
            <a
              href="#main-menu-toggle"
              id="main-menu-close"
              className="menu-close"
              aria-label="Close main menu"
            >
              <span className="sr-only">Close main menu</span>
              <span className="fa fa-times" aria-hidden="true"></span>
            </a>
            <ul>
              <li>
                <Link to="/warehouse">
                  <span className="fa fa-building" aria-hidden="true"></span>
                  Warehouse
                </Link>
              </li>
              <li>
                <Link to="/shipping">
                  <span className="fa fa-ship" aria-hidden="true"></span>
                  Shipping
                </Link>
              </li>
              <li>
                <Link to="/help">
                  <span className="fa fa-headphones" aria-hidden="true"></span>
                  Help
                </Link>
              </li>
            </ul>
          </nav>
          <a
            href="#main-menu-toggle"
            className="backdrop"
            aria-hidden="true"
            hidden
          ></a>
          <div className="container-wrapper">
            <Header />

            <div className="">
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/home" component={Home} />
                <Route path="/search" component={Search} />
                <Route path="/cart" component={Cart} />
                <Route path="/warehouse" component={Warehouse} />
                <Route path="/shipping" component={Shipping} />
                <Route path="/help" component={Help} />
                <Route path="/product-page" component={ProductPage} />
                <Route component={Home}/>
              </Switch>
            </div>

            <Toolbar />
          </div>
        </div>
      </Router>
    </Store>
  );
};

render(<App />, document.getElementById('root'));
